export const responseAmazonDSPBrands = {
  data: []
};